export const brandConfigObjectMap = new Map();

export const Brands = {
    MtnSouthAfricaEnglish: 'vc-za-en',
};

brandConfigObjectMap.set(Brands.MtnSouthAfricaEnglish, {
    productId: 44,
    productTitle: 'Goal Rush',
    categoryId: null,
    showTermsConditions: true,
    showDataWon: true,
    serviceId: 'goal-rush-daily',
    newIntegration: false,
    baseRoute: '/landing'
});
